export default function getRulesReducer(state=[], action) {
    switch(action.type){
        case "get_rules_suc": {
            return action.payload.rules
        }
        default: {
            return state
        }
    }
}